import './filter-list-events.scss';
import Selectr from 'Selectr';

class FilterListEvents {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-filter-list-events'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$filterListEvents = element;
    }

    initialize () {
        this.initFilter();
        this.setEvents();
    }

    initFilter () {
        const $$selects = this.$filterListEvents.querySelectorAll('select');

        console.log($$selects);

        if ($$selects.length > 0) {
            for (let i = 0; i < $$selects.length; i++) {
                const $select = $$selects[i];
    
                this.select = new Selectr($select, {
                    searchable: false,
                    clearable: false,
                    defaultSelected: false,
                    placeholder: $select.getAttribute('placeholder')
                });
            }
        }
    }

    setEvents () {}
}

export { FilterListEvents };

window.addEventListener('content.loaded', (e) => {
    
    const eventDetails = e.detail;
    const context = eventDetails.$context;
    
    if (context) {
        const $$$filterListEvents = context.querySelectorAll('[data-filter-list-events="root"]');
        for (let i = 0; i < $$$filterListEvents.length; i++) {
            const $$filterListEvents = $$$filterListEvents[i];

            const $$filterListEventsAPI = new FilterListEvents($$filterListEvents);
            $$filterListEventsAPI.initialize();
        }
    }
});
